import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: 21
  },
  optionsContent: {
    marginLeft: 15,
    marginTop: 10
  },
  radio: {
    "&$checked": {
      color: theme.palette.error.main
    }
  },
  checked: {},
  errorText: {
    color: theme.palette.error.main
  }
}));
const QuizQuestion = ({
  content,
  sectionIndex,
  handleAnswerChange
}) => {
  var _content$answers;
  const classes = useStyles();
  const shouldQuestionVisible = content.title !== "" && content.answers.filter(answer => answer.text !== "").length >= 2 && typeof content.correctAnswer !== "undefined";
  return shouldQuestionVisible && /*#__PURE__*/React.createElement(Grid, {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "textPrimary",
    className: content.wrongAnswer && classes.errorText
  }, sectionIndex, ". ", content.title), /*#__PURE__*/React.createElement(RadioGroup, {
    className: classes.optionsContent,
    onChange: (event, value) => handleAnswerChange && handleAnswerChange(value, sectionIndex),
    value: typeof content.selectedAnswer === "number" ? content.selectedAnswer : null
  }, (_content$answers = content.answers) === null || _content$answers === void 0 ? void 0 : _content$answers.map((answer, index) => {
    return answer.text !== "" && /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Radio, {
        classes: content.wrongAnswer && {
          root: classes.radio,
          checked: classes.checked
        }
      }),
      label: answer.text,
      value: index,
      key: index
    });
  })));
};
QuizQuestion.propTypes = {
  content: PropTypes.object.isRequired,
  sectionIndex: PropTypes.number,
  handleAnswerChange: PropTypes.func
};
export default QuizQuestion;